import CommonSaveData from "../../LTGame/Commom/CommonSaveData";
import { EPlatformType } from "../../LTGame/Platform/EPlatformType";
import LTPlatform from "../../LTGame/Platform/LTPlatform";
import BaseUIMediator from "../../LTGame/UIExt/FGui/BaseUIMediator";
import LTSDK from "../../SDK/LTSDK";
import UI_Main from "../../ui/Main/UI_Main";
import GameData from "../common/GameData";
import GlobalUnit from "../common/GlobalUnit";
import AudioManager from "../manager/AudioManager";
import { UI_ChallengeMediator } from "./UI_ChallegeMediator";
import { UI_CustomMediator } from "./UI_CustomMediator";
import { UI_SkillMediator } from "./UI_SkillMediator";
import { UI_StoreMediator } from "./UI_StoreMediator";
import { UI_SuperMediator } from "./UI_SuperMediator";
export class UI_MainMediator extends BaseUIMediator {
    constructor() {
        super(...arguments);
        this.skillList = [
            0, 1
        ];
    }
    static get instance() {
        if (this._instance == null) {
            this._instance = new UI_MainMediator();
            this._instance._classDefine = UI_Main;
        }
        return this._instance;
    }
    _OnShow() {
        super._OnShow();
        // UI_GetMediator.instance.Show(PetConfig.data[1]);
        AudioManager.instance.PlayById(10);
        this.ui.m_img_bg.onClick(this, this.ClickStart);
        this.ui.m_btn_sound.onClick(this, this.SetSound);
        this.ui.m_btn_viberate.onClick(this, this.SetViberate);
        if (LTPlatform.instance.platform == EPlatformType.Web4399) {
            this.ui.m_btn_viberate.visible = false;
            let text = new fgui.GTextField();
            text.text = '4399';
            this.ui.addChild(text);
            text.x = this.ui.m_btn_viberate.x;
            text.y = this.ui.m_btn_viberate.y;
        }
        this.ui.m_btn_selfdesign.onClick(this, this.showSelfLevel);
        // this.ui.m_btn_upgrade.onClick(this, this.ShowUpgrade);
        this.ui.m_btn_store.onClick(this, this.ShowStore);
        this.ui.m_btn_challenge.onClick(this, () => __awaiter(this, void 0, void 0, function* () {
            this.showLevels(4);
        }));
        this.ui.m_btn_xiyou.onClick(this, () => __awaiter(this, void 0, void 0, function* () {
            this.showLevels(5);
        }));
        this.ui.m_btn_store.m_red.selectedIndex = GameData.instance.shopRed ? 1 : 0;
        let list = this.ui.m_list_view;
        list.itemRenderer = Laya.Handler.create(this, this.RenderItem, null, false);
        list.on(fairygui.Events.CLICK_ITEM, this, this.ClickItem);
        this.CheckPlatfrom();
        this.RefreshBtnUI();
        this.RefreshUI();
        if (!LTSDK.instance.isInCheck && GlobalUnit.game.gameCount > 1 && GlobalUnit.game.gameCount % 2 == 0) {
            this.ShowStore();
        }
        if (LTPlatform.instance.platform == EPlatformType.WX) {
            LTPlatform.instance.showGameBoxBannerAd();
        }
    }
    showLevels(mode) {
        return __awaiter(this, void 0, void 0, function* () {
            if (GlobalUnit.dataManager.IsModeUnlocked(mode)) {
                UI_ChallengeMediator.instance.Show(mode);
            }
            else {
                if (yield LTPlatform.instance.ShowRewardVideoAdAsync()) {
                    GlobalUnit.dataManager.UnlockMode(mode);
                    UI_ChallengeMediator.instance.Show(mode);
                    this.RefreshUI();
                }
            }
        });
    }
    showSelfLevel() {
        return __awaiter(this, void 0, void 0, function* () {
            if (GlobalUnit.dataManager.IsModeUnlocked(2)) {
                UI_CustomMediator.instance.Show(2);
            }
            else {
                if (yield LTPlatform.instance.ShowRewardVideoAdAsync()) {
                    GlobalUnit.dataManager.UnlockMode(2);
                    UI_CustomMediator.instance.Show(2);
                    this.RefreshUI();
                }
            }
        });
    }
    ClickStart(e) {
        e.stopPropagation();
        if (!LTSDK.instance.isInCheck && GameData.instance.levelId > 1) {
            this.Hide();
            UI_SuperMediator.instance.Show(() => {
                GlobalUnit.game.StartGame();
            });
        }
        else {
            GlobalUnit.game.StartGame();
        }
    }
    ClickItem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            AudioManager.instance.PlayById(5);
            let index = item.data;
            let type = this.skillList[index];
            let config = GlobalUnit.dataManager.GetSkillConfig(type);
            if (config.cost_type == 2) {
                return;
            }
            if (config.cost_value == 1 || GameData.instance.coinCount < config.cost_value) {
                // if (!LTSDK.instance.configs.isADEnable) {
                //     return LTUI.Toast("金币不足");
                // }
                let res = yield LTPlatform.instance.ShowRewardVideoAdAsync();
                if (!res) {
                    return;
                }
                LTPlatform.instance.RecordEvent('game_ad', { level_id: GlobalUnit.game.level.config.id, id: 'skill_' + config.skill_type });
            }
            else {
                GameData.instance.coinCount -= config.cost_value;
            }
            GlobalUnit.dataManager.UpgradeSkill(type);
            GameData.SaveToDisk();
            this.RefreshUI();
        });
    }
    RenderItem(index, item) {
        item.data = index;
        let type = this.skillList[index];
        let config = GlobalUnit.dataManager.GetSkillConfig(type);
        item.m_skill_type.selectedIndex = type;
        if (config.cost_type != 0) {
            item.m_cost_type.selectedIndex = config.cost_type;
        }
        else {
            if (GameData.instance.coinCount < config.cost_value) {
                item.m_cost_type.selectedIndex = 1;
                LTPlatform.instance.RecordEvent('game_ad_show', { level_id: GlobalUnit.game.level.config.id, id: 'skill_' + config.skill_type });
            }
            else {
                item.m_text_count.text = config.cost_value.toString();
            }
        }
        if (config.cost_type != 2) {
            item.m_text_level.text = config.skill_level + "j";
        }
    }
    RefreshUI() {
        this.ui.m_com_level.m_text_level.text = "l" + GlobalUnit.game.level.config.id;
        this.ui.m_com_coin.m_text_count.text = GameData.instance.coinCount.toString();
        let list = this.ui.m_list_view;
        list.numItems = this.skillList.length;
        this.ui.m_btn_challenge.m_ad.selectedIndex = GlobalUnit.dataManager.IsModeUnlocked(4) ? 0 : 2;
        this.ui.m_btn_selfdesign.m_ad.selectedIndex = GlobalUnit.dataManager.IsModeUnlocked(2) ? 0 : 1;
        this.ui.m_btn_xiyou.m_ad.selectedIndex = GlobalUnit.dataManager.IsModeUnlocked(4) ? 0 : 1;
    }
    ShowStore() {
        AudioManager.instance.PlayById(1);
        GameData.instance.shopRed = false;
        GameData.SaveToDisk();
        this.ui.m_btn_store.m_red.selectedIndex = GameData.instance.shopRed ? 1 : 0;
        UI_StoreMediator.instance.Show();
    }
    ShowUpgrade() {
        AudioManager.instance.PlayById(1);
        UI_SkillMediator.instance.Show();
    }
    SetSound(e) {
        e.stopPropagation();
        AudioManager.instance.PlayById(1);
        CommonSaveData.instance.isMusicOn = !CommonSaveData.instance.isMusicOn;
        if (!CommonSaveData.instance.isMusicOn) {
            AudioManager.instance.Pause();
        }
        else {
            AudioManager.instance.Resume();
        }
        this.RefreshBtnUI();
    }
    SetViberate(e) {
        e.stopPropagation();
        AudioManager.instance.PlayById(1);
        CommonSaveData.instance.isShakeOn = !CommonSaveData.instance.isShakeOn;
        this.RefreshBtnUI();
    }
    CheckPlatfrom() {
        if (LTSDK.instance.isInCheck || GameData.instance.levelId == 1) {
            this.ui.m_btn_store.visible = false;
            this.ui.m_btn_selfdesign.visible = false;
            this.ui.m_btn_challenge.visible = false;
            this.ui.m_btn_xiyou.visible = false;
            this.ui.m_list_view.visible = false;
        }
        else {
            this.ui.m_btn_store.visible = true;
            this.ui.m_list_view.visible = true;
        }
    }
    RefreshBtnUI() {
        if (CommonSaveData.instance.isShakeOn) {
            this.ui.m_btn_viberate.icon = "ui://c6t3i6k8jh461h";
        }
        else {
            this.ui.m_btn_viberate.icon = "ui://c6t3i6k8jh461i";
        }
        if (CommonSaveData.instance.isMusicOn) {
            this.ui.m_btn_sound.icon = "ui://c6t3i6k8jh461e";
        }
        else {
            this.ui.m_btn_sound.icon = "ui://c6t3i6k8jh461f";
        }
    }
    _OnHide() {
        LTPlatform.instance.hideGameBoxBannerAd();
    }
}
